import { IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";

export default class AuditService extends ServiceBase {
  all = () : Promise<IResponse<any[]>> => 
    this.GetFetch<IResponse<any[]>>('entity/audit/all', {});
}